import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IToastAction, ToastType } from './services/toast.service';

const ICONES: Record<ToastType, string> = {
  success: 'fa-check-circle',
  warning: 'fa-exclamation-triangle',
  error: 'fa-exclamation-circle',
  info: 'fa-info-circle'
};

@Component({
  selector: 'sgt-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
  @Input() title?: string;
  @Input() message: string;
  @Input() type: ToastType = 'info';
  @Input() duration = 0;
  @Input() action?: IToastAction;

  @Output() closed = new EventEmitter<void>();

  private timer?: ReturnType<typeof setTimeout>;

  get icone(): string {
    return ICONES[this.type];
  }

  get isExpandido(): boolean {
    return !!this.title;
  }

  get temBotaoFechar(): boolean {
    return this.isExpandido || !this.duration;
  }

  ngOnInit(): void {
    this.iniciarTimer();
  }

  ngOnDestroy(): void {
    this.pausar();
  }

  pausar(): void {
    clearTimeout(this.timer);
  }

  iniciarTimer(): void {
    this.pausar();
    if (this.duration > 0) {
      this.timer = setTimeout(() => this.close(), this.duration);
    }
  }

  executarAcao(): void {
    this.action?.onClick();
    this.close();
  }

  close(): void {
    this.closed.emit();
  }
}
